import React from 'react';
import { batteryToText } from 'utils/utils';
import statusConverter from 'utils/statusConverter';

export const columnSetter = (moduleScn, flag) => {
  const columns = [
    {
      Header: '장치정보',
      columns: [
        {
          Header: 'No',
          accessor: 'rnum',
        },
        {
          Header: '장치명',
          accessor: 'modelNm',
        },
        {
          Header: '도크',
          accessor: 'areaNo',
        },
        {
          Header: '안벽',
          accessor: 'areaNm',
        },
        {
          Header: '호선',
          accessor: 'shipNo',
        },
        {
          Header: '장소',
          accessor: 'locationNm',
        },
      ],
    },
    {
      Header: '측정결과',
      columns: [
        {
          Header: (
            <span>
              O<sub>2</sub>(%)
            </span>
          ),
          accessor: 'o2',
        },
        {
          Header: (
            <span>
              H<sub>2</sub>S(ppm)
            </span>
          ),
          accessor: 'h2s',
        },
        {
          Header: <span>CO(ppm)</span>,
          accessor: 'co',
        },
        {
          Header: () => flag === "0" ? <span>CH4(%)</span> : <span>HC(%)</span>,
          accessor: 'hc',
        },
        {
          Header: (
            <span>
              CO<sub>2</sub>(%)
            </span>
          ),
          accessor: 'co2',
        },
        {
          Header: (
            <span>
              CH<sub>3</sub>OH(ppm)
            </span>
          ),
          accessor: 'methanol',
        },
        {
          Header: (
            <span>
              NH<sub>3</sub>(ppm)
            </span>
          ),
          accessor: 'nh3',
        },
      ],
    },
    {
      Header: '상태정보',
      columns: [
        {
          Header: 'seqnum',
          accessor: 'seqnum',
        },
        {
          id: 'status',
          Header: () => <div>상태</div>,
          Cell: ({ row }) => statusConverter(row.original.status, row.original.statusCode),
        },
        {
          Header: 'rssi',
          accessor: 'rssi',
        },
        {
          id: 'Battery',
          Header: () => <div>Battery(%)</div>,
          Cell: ({ row }) => batteryToText(row.original.battery),
        },
        {
          Header: '측정시간',
          accessor: 'regTime',
        },
      ],
    },
  ];

  return columns;
};
